module.exports = __webpack_public_path__ + "img/youtube.a6372485.svg";